var map = {
	"./logo_mottosokka02_dev.svg": 34081,
	"./logo_mottosokka02_local.svg": 44677,
	"./logo_mottosokka02_prd.svg": 73022,
	"./logo_mottosokka02_stg.svg": 92148,
	"./logo_mottosokka02_sub.svg": 76250,
	"./logo_mottosokka02_tst.svg": 80285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86213;